export const transitionSides = {
    bottom: 'bottom',
    left: 'left',
    right: 'right',
    top: 'top',
};
